import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const searchExcludeAPI = createApi({
  reducerPath: 'searchExcludeAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/AppsManage' }),
  endpoints: (build) => ({
    fetchSerachAdvertisers: build.query({
      query: (term) => ({
        url: `/GetSearchAdvertisers`,
        params: {
          platform_id: 1,
          term,
          page_no: 1,
          page_size: 50,
        },
      }),
    }),
    fetchSerachCampaigns: build.query({
      query: (term) => ({
        url: `/GetSearchCampaigns`,
        params: {
          platform_id: 1,
          term,
          page_no: 1,
          page_size: 50,
        },
      }),
    }),
    fetchSerachPublishers: build.query({
      query: (term) => ({
        url: `/GetSearchPublishers`,
        params: {
          platform_id: 1,
          term,
          page_no: 1,
          page_size: 50,
        },
      }),
    }),
    fetchSerachApplications: build.query({
      query: (term) => ({
        url: `/SearchExcludeApps`,
        params: {
          term,
        },
      }),
    }),
    fetchSearchPublisherApplications: build.query({
      query: (term) => ({
        url: `/SearchExcludePublisherApps`,
        params: {
          term,
        },
      }),
    }),
  }),
});
